/*
 * Extends Dawn's SliderComponent to add pagination dots. The dot count depends on how
 * many cards fit on screen, which changes with the viewport, so they are built in JS
 * from the page count the slider already works out rather than rendered in Liquid.
 *
 * Shared by any section that wants an arrows + dots carousel.
 */
if (typeof SliderComponent !== 'undefined' && !customElements.get('dots-carousel')) {
  customElements.define(
    'dots-carousel',
    class DotsCarousel extends SliderComponent {
      initPages() {
        super.initPages();
        this.renderDots();
        this.syncDots();
      }

      update() {
        super.update();
        this.syncDots();
      }

      get dotsContainer() {
        return this.querySelector('[data-carousel-dots]');
      }

      renderDots() {
        const container = this.dotsContainer;
        if (!container || !this.totalPages) return;

        // Only rebuild when the page count actually changed - this runs on every resize.
        if (container.childElementCount === this.totalPages) return;

        container.innerHTML = '';

        for (let i = 0; i < this.totalPages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dots-carousel__dot';
          dot.setAttribute('aria-label', `Go to page ${i + 1} of ${this.totalPages}`);
          if (this.slider && this.slider.id) dot.setAttribute('aria-controls', this.slider.id);
          dot.addEventListener('click', () => this.setSlidePosition(i * this.sliderItemOffset));
          container.appendChild(dot);
        }
      }

      syncDots() {
        const container = this.dotsContainer;
        if (!container) return;

        Array.from(container.children).forEach((dot, index) => {
          const isActive = index === this.currentPage - 1;
          dot.classList.toggle('dots-carousel__dot--active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
